<!-- 选择多个加工 -->
<template>
  <div>
    <el-dialog
      title="选择加工"
      width="1400px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <!-- 表格 -->
        <vxe-grid
          ref="refTable"
          v-bind="tableOptions"
          @keydown="tableKeydown"
          @current-change="tableCurrentChange"
        >
          <!-- slot_header -->
          <template #header_input="{ column }">
            <c-table-header
              :title="column.title"
              :field="column.field"
              :url="headerFilterUrl"
              @change="headerFilterChange"
            />
          </template>
          <!-- slot_default -->
          <template #default_she_bei_list="{ row }">
            <span v-if="row.she_bei_list">{{ row.she_bei_list[0].name }}</span>
          </template>
          <template #default_she_bei_mu_ban_list="{ row }">
            <div v-if="row.she_bei_list && row.she_bei_list.length">
              <div v-for="(item, index) in row.she_bei_list[0].she_bei_mu_ban_list" :key="index">
                {{ item.mu_ban_ming_cheng }}
              </div>
            </div>
          </template>

          <!-- slot_pager -->
          <template #pager>
            <div></div>
            <vxe-pager v-bind="tableOptions.pagerConfig" @page-change="pageChange" />
          </template>
        </vxe-grid>
      </div>
      <div slot="footer">
        <el-button size="mini" type="success" @click="popupMoBanDo">新增模板</el-button>
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>

    <!-- 弹窗-增改模板 -->
    <PopupDoMuBan
      v-if="isShowPopupDoMuBan"
      :show.sync="isShowPopupDoMuBan"
      :bao_han="['加工']"
      @success="searchListData"
    />
  </div>
</template>

<script>
import PopupDoMuBan from '../../mu-ban/common/popup-do-mu-ban'
export default {
  components: {
    PopupDoMuBan
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    gui_ge_shi_li: {
      type: String,
      default: ''
    },
    dan_wei: {
      type: String,
      default: ''
    },
    dan_jian_shu_liang: {
      type: [String, Number],
      default: ''
    },
    mu_ban_id: {
      type: [String, Number]
    }
  },
  data() {
    return {
      selfShow: false,

      filterData: {
        lei_mu_name: '',
        mu_ban_id: ''
      },

      headerFilterUrl: '/admin/gcvip/muBan/searchHeard',
      tableOptions: {
        loading: true,
        size: 'mini',
        border: true,
        'max-height': this.$util.getViewHeight() - 148,
        pagerConfig: {
          ...this.$constant.page
        },
        columns: [
          { type: 'checkbox', width: 40 },
          { field: 'mu_ban_ming_cheng', title: '模板名称', slots: { header: 'header_input' } },
          { field: 'mu_ban_guan_jian_ci', title: '模板关键词', slots: { header: 'header_input' } },
          { field: 'id', title: '模板编码', slots: { header: 'header_input' } },
          { field: 'lei_mu_name', title: '类目', slots: { header: 'header_input' } },
          {
            title: '绑定设备',
            slots: { default: 'default_she_bei_list' }
          },
          {
            title: '绑定原料模板',
            slots: { default: 'default_she_bei_mu_ban_list' }
          }
        ],
        data: []
      },
      isShowPopupDoMuBan: false
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getListData()
  },
  methods: {
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.tableOptions.pagerConfig.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.tableOptions.loading = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/muBan/list',
        data: {
          currentPage: this.tableOptions.pagerConfig.currentPage,
          pageSize: this.tableOptions.pagerConfig.pageSize,
          bao_han: ['加工'],
          she_bei_mu_ban_id: this.mu_ban_id,
          filterData: this.filterData,
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            this.tableOptions.data = res.data.page.list
            this.tableOptions.pagerConfig.pageSize = res.data.page.pageSize
            this.tableOptions.pagerConfig.total = res.data.page.totalRow
            this.tableOptions.pagerConfig.currentPage = res.data.page.pageNumber
          }
        })
        .catch(() => {})
        .then(() => {
          this.tableOptions.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.tableOptions.pagerConfig.currentPage = currentPage
      this.tableOptions.pagerConfig.pageSize = pageSize
      this.getListData()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setCheckboxRow(params.row, true) // 选中checkbox
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowCheckbox = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isCurrentRowCheckbox) // 选中checkbox
      }
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 获取-当前复选行
    getCheckboxRecords() {
      return this.$refs.refTable.getCheckboxRecords()
    },
    // 项-模板增改
    popupMoBanDo() {
      this.isShowPopupDoMuBan = true
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      let rows = this.getCheckboxRecords()
      if (!rows) {
        this.itemChoosePrompt()
        return
      }
      let resultList = []
      rows.forEach((itemSt) => {
        let resultItem = {
          id: itemSt.id, // 模板编码
          mu_ban_ming_cheng: itemSt.mu_ban_ming_cheng, // 模板名称
          mu_ban_guan_jian_ci: itemSt.mu_ban_guan_jian_ci, // 模板关键词
          gui_ge_shi_li: this.gui_ge_shi_li, // 规格
          dan_wei: this.dan_wei, // 单位
          dan_jian_shu_liang: this.dan_jian_shu_liang, // 单件数量
          dan_jia: '', // 单价
          dan_jian_jin_e: '', // 单件金额
          she_bei_mu_ban_data: {}
        }
        let danWeiList = this.dan_wei.split(',')
        itemSt.she_bei_list.forEach((itemNd) => {
          itemNd.she_bei_mu_ban_list.forEach((itemRd) => {
            if (this.mu_ban_id === itemRd.shang_pin_mu_ban_id) {
              let result = this.$util.deepCopy(itemRd)
              result.gui_ge_shi_li = this.gui_ge_shi_li
              resultItem.she_bei_mu_ban_data = result
              this.$tool.actionVerify(
                resultItem.she_bei_mu_ban_data,
                resultItem.she_bei_mu_ban_data
              ) // 开始校验
              resultItem.she_bei_mu_ban_data.dan_wei_zu_list.forEach((danWeiItemSt) => {
                danWeiItemSt.dan_wei_list.forEach((danWeiItemNd) => {
                  if (
                    (danWeiItemSt.dan_wei_zu_name === danWeiList[1],
                    danWeiItemNd.dan_wei_name === danWeiList[0])
                  ) {
                    resultItem.dan_jia = danWeiItemNd.verify_price_val
                    resultItem.dan_jian_jin_e = this.$XEUtils.multiply(
                      resultItem.dan_jia,
                      resultItem.dan_jian_shu_liang
                    )
                  }
                })
              })
            }
          })
        })
        resultList.push(resultItem)
      })

      this.popupCancel()
      this.$emit('success', resultList)
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
